export enum FinnovaLanguage {
    GERMAN = 1,
    FRENCH = 2,
    ITALIAN = 3,
    ENGLISH = 5,
}

// these codes reappear in multiple finnova code tables and tend to have the same or simillar meaning
export enum FinnovaCommonCodes {
    NONE = '0', // "Kein"
    UNKNOWN = '9', // "Nicht bekannt"
}

// "Zivilstand"
export enum FinnovaCivilStatusCode {
    NONE = '0', // "Kein"
    UNWED = '1', // "Ledig"
    MARRIED = '2', // "Verheiratet"
    DIVORCED = '3', // "Geschieden"
    WIDOWED = '4', // "Verwitwet"
    LEGALLY_SEPARATED = '5', // "Gerichtlich getrennt"
    UNKNOWN = '9', // "Nicht bekannt"
    REGISTERED_PARTNERSHIP = '10', // "In eingetragener Partnerschaft"
    TERMINATED_REGISTERED_PARTNERSHIP = '11', // "Aufgehobene eingetragene Partnerschaft"
}

// "Güterstand"
export enum FinnovaPropertyRegimeCode {
    NONE = '0', // "Kein"
    COMMUNITY_OF_ACQUISITIONS = '1', // "Errungenschaftsbeteiligung"
    COMMUNITY_OF_PROPERTY = '2', // "Gütergemeinschaft"
    SEPARATION_OF_PROPERTY = '3', // "Gütertrennung"
    UNKNOWN = '9', // "Güterstand nicht bekannt"
}

export const portalToFinnovaLanguageMap = {
    de: FinnovaLanguage.GERMAN,
    en: FinnovaLanguage.ENGLISH,
    fr: FinnovaLanguage.FRENCH,
    it: FinnovaLanguage.ITALIAN,
};

export const finnovaToPortalLanguageMap = {
    [FinnovaLanguage.GERMAN]: 'de',
    [FinnovaLanguage.ENGLISH]: 'en',
    [FinnovaLanguage.FRENCH]: 'fr',
    [FinnovaLanguage.ITALIAN]: 'it',
};

export interface IFinnovaCode {
    userbank: number;
    tabelle: string;
    code: string;
    sprache: FinnovaLanguage;
    bezLang: string;
    bezMittel: string;
    bezKurz: string;
}
